import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import useReveal from '../../../shared/hooks/useReveal';

const CTA = () => {
  const [ref, visible] = useReveal({ threshold: 0.2 });
  const [count, setCount] = useState(0);
  const started = useRef(false);

  useEffect(() => {
    if (!visible || started.current) return;
    started.current = true;
    const target = 2847103;
    const duration = 2500;
    const start = performance.now();
    const tick = (now) => {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setCount(Math.floor(eased * target));
      if (progress < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }, [visible]);

  return (
    <section id="contact" className="relative py-32 md:py-44 bg-zinc-950 overflow-hidden">
      <div ref={ref} className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-end">
          {/* Left - big statement */}
          <div className="lg:col-span-7">
            <div className={`flex items-center gap-4 mb-8 reveal from-left ${visible ? 'visible' : ''}`}>
              <div className="h-px w-12 bg-zinc-600" />
              <span className="text-xs uppercase tracking-[0.25em] text-zinc-500">
                Early Access
              </span>
            </div>

            {/* Live counter */}
            <div className={`mb-6 reveal from-below ${visible ? 'visible' : ''}`}
                 style={{ transitionDelay: '0.1s' }}>
              <span className="text-5xl md:text-7xl font-extralight text-white tabular-nums tracking-tight">
                {count.toLocaleString()}
              </span>
              <span className="block text-[10px] uppercase tracking-[0.25em] text-zinc-600 mt-2">
                data points synced and counting
              </span>
            </div>

            <h2 className={`text-4xl md:text-5xl lg:text-6xl font-light text-white leading-[1.1] reveal from-below ${visible ? 'visible' : ''}`}
                style={{ transitionDelay: '0.25s' }}>
              Something smarter<br />
              <span className="text-zinc-600">is coming.</span>
            </h2>
          </div>

          {/* Right - CTA */}
          <div className={`lg:col-span-4 lg:col-start-9 reveal from-below ${visible ? 'visible' : ''}`}
               style={{ transitionDelay: '0.3s' }}>
            <p className="text-zinc-400 text-base leading-relaxed mb-8">
              Be among the first to experience operational intelligence
              built for the real world.
            </p>
            <Link
              to="/signup"
              className="group inline-flex items-center gap-3 text-sm tracking-wider text-white uppercase"
            >
              Get started
              <span className="inline-block w-8 h-px bg-white group-hover:w-14 transition-all duration-500" />
            </Link>
            <p className="text-zinc-600 text-xs mt-6 tracking-wide">
              contact@arbcor.com
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
